import { RENDERER_MODE } from '@/constants';
import { defineVuexModule } from '../helpers';

export default defineVuexModule({
  namespaced: true,
  state: {
    showGrid: !RENDERER_MODE,
    snapToGrid: true,
    zoomControls: true,
    panControls: true,
    seatmapName: 'Seatmap name',
    scale: 1,
  },

  /* eslint-disable no-shadow, max-len, no-param-reassign*/
  getters: {},

  actions: {
    setSnapToGrid({ commit, state }, flag) {
      if (state.snapToGrid === flag) return;
      commit('snapToGrid', flag);
    },
    hidePanControls(context) {
      context.commit('togglePanControls', false);
    },
    showPanControls(context) {
      context.commit('togglePanControls', true);
    },
    disableGrid(context) {
      context.commit('toggleGrid', false);
    },
    enableGrid(context) {
      context.commit('toggleGrid', true);
    },
    toggleGrid({ commit, state }) {
      commit('toggleGrid', !state.showGrid);
    },
    setGrid(context, flag) {
      context.commit('toggleGrid', flag);
    },
    setSeatmapName(context, name) {
      context.commit('seatmapName', name);
    },
  },

  mutations: {
    togglePanControls(state, flag) {
      state.panControls = flag;
    },
    toggleGrid(state, flag) {
      state.showGrid = flag;
    },
    snapToGrid(state, flag) {
      state.snapToGrid = flag;
    },
    seatmapName(state, name) {
      state.seatmapName = name;
    },
    setScale(state, scale) {
      state.scale = scale;
    },
  },
});
